export const phone_media = "only screen and (max-width : 576px)"